import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './vip.css'

const VIP = (props) => {
  return (
    <div className="vip-container1">
      <Helmet>
        <title>Reichsarbeitsdienst in Arras - marjangerrits.nl</title>
        <meta
          name="description"
          content="Albert Woltjes was voor de Reichsarbeitsdienst in Arras en in een lazaret in Lille"
        />
        <meta
          property="og:title"
          content="Reichsarbeitsdienst in Arras - marjangerrits.nl"
        />
        <meta
          property="og:description"
          content="Albert Woltjes was voor de Reichsarbeitsdienst in Arras en in een lazaret in Lille"
        />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name14"></NavbarInteractive>
      <div className="vip-blogtitel-en-datum">
        <div className="vip-container2">
          <h1 className="vip-titel">Ben jij wel eens als VIP uitgenodigd?</h1>
        </div>
      </div>
      <div className="vip-container3">
        <p className="vip-datum">
          <span>28-09-2023</span>
          <br></br>
        </p>
        <img
          alt="image"
          src="/Blog foto's/arras-1500h.jpg"
          className="vip-foto"
        />
        <span className="vip-tekst">
          <span>
            Nou, ik wel. En het bracht een wirwar aan gevoelens met zich mee.
            Het gebeurde tijdens een reis naar de plaatsen in Frankrijk waar
            mijn schoonvader tijdens de Tweede Wereldoorlog geweest is. De
            eerste stop was in Arras, ook wel Atrecht genoemd. Mijn schoonvader
            was daar voor de
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span className="Schuingedrukt_tekst">Reichsarbeitsdienst</span>
          <span>
            . We hebben de vermoedelijke school gevonden waar hij verbleef,
            tegenover een park waar hij ’s morgens zijn sportoefeningen deed met
            daarnaast een paleis zoals hij in zijn brieven beschreef. We
            wandelden langs alle herkenningspunten en toen we terugliepen naar
            de halte van het gratis rijdende elektrische busje (idee voor
            Nederland?), kwamen we een in vol ornaat geklede veteraan tegen. We
            groetten elkaar en liepen verder.
          </span>
          <br></br>
          <br></br>
          <span>
            Als we bij de halte staan te wachten, zien we steeds meer militairen
            aankomen. Ze verzamelen zich enkele tientallen meters bij ons
            vandaan. Met belangstelling slaan we ze gade. Helaas is ons Frans
            niet zo goed en een gesprek aangaan is daardoor lastig. Als er een
            jongeman langsloopt, spreken we hem aan, hij spreekt vast een paar
            woorden Engels. Zodra we hem gevraagd hebben waarom de militairen
            zich hier verzamelen, wordt hij opzij geschoven door een man van een
            jaar of vijftig, jasje vol lintjes, die zichzelf duidelijk
            belangrijker vindt dan de jongeman. Hij legt in slecht maar
            begrijpelijk Engels uit dat ze bijeenkomen omdat Arras op 1
            september 1944, vandaag 79 jaar geleden, bevrijd is. Ze worden zo
            opgehaald door een bus en rijden naar de Engelse begraafplaats. Een
            indrukwekkende begraafplaats, weten we, want we zijn er die ochtend
            zelf geweest. Van daaruit gaan ze naar het monument tegenover het
            station en dan marcheren ze naar het stadhuis.
          </span>
          <br></br>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <span>
            &apos;Willen jullie met ons mee?’ vraagt de lintjesman plotseling.
          </span>
          <br></br>
          <span>
            Ik schrik van de vraag. Hij heeft geen idee wie wij zijn en al
            helemaal niet dat we hier zijn om te onderzoeken waar een Duitser in
            1943 een stukje van zijn militaire opleiding heeft gekregen, want
            daar werd de
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span className="Schuingedrukt_tekst">Reichsarbeitsdienst</span>
          <span>
            {' '}
            toen zeker voor gebruikt. En diezelfde Duitsers heeft later als
            soldaat in Frankrijk gediend.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <span>
            ‘Nou, we wachten op onze bus en willen terug naar ons onderkomen’,
            stamel ik terwijl ik mijn vriendin aankijk.
          </span>
          <br></br>
          <span>
            ‘Je kan toch met onze bus mee’, antwoordt de man. ‘Jullie kunnen mee
            als onze VIP’s.’
          </span>
          <br></br>
          <br></br>
          <span>
            Ik voel me gevleid. Wanneer krijg je nou zo’n uitnodiging. Als ik
            mijn vriendin aankijk zie ik dat ze twijfelt. Toch voelt het niet
            goed. Waarom nodigt die man ons uit? Om de een of ander reden wil
            hij blijkbaar met ons pronken. En wat als het gesprek komt op wat
            wij hier in Arras doen? Ik ga niet liegen maar juist deze mensen
            vertellen waarom we hier zijn… ik voel plaatsvervangende schaamte.
            De schaamte die mijn vriendin en mensen uit Duitsland van haar
            generatie zo vaak gevoeld hebben vanwege de betrokkenheid van
            familieleden, vaak een vader of oom, in de Tweede Wereldoorlog en
            die diep van binnen bij velen nog aanwezig is. Het gevoel van schuld
            en schaamte dat ik eerder niet zo goed begreep. Nu maak ik het zelf
            mee.
          </span>
          <br></br>
          <br></br>
          <span>
            Ons busje komt aangereden en sjeest ons bijna voorbij. Ik spring net
            op tijd naar voren om hem aan te houden, bedank de man voor zijn
            uitnodiging en we snellen de bus in.
          </span>
          <br></br>
          <br></br>
        </span>
      </div>
      <div className="vip-andere-blogs">
        <h2 className="vip-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="vip-laatste3-blogposts"></div>
      </div>
      <Footer rootClassName="footerroot-class-name15"></Footer>
    </div>
  )
}

export default VIP
